<template>
  <div class="navi-setting-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="tool-drawer-title">{{$t('edit.guide.pcTitle')}}</div>
    </div>

    <div style="margin:10px 20px; ">
      <div style="display: flex;justify-content: space-between;margin-bottom:10px;">
        <span>{{$t('edit.guide.gapTimePc')}}</span>
        <span>{{$t('edit.guide.gap.unit')}}：{{$t('edit.guide.gap.unitSecond')}}</span>
      </div>
      <a-input-number v-model="gapTime" :placeholder="$t('edit.guide.gap.timeHolder')" :min="0" />

      <div style="margin:20px 0 10px;">{{$t('edit.guide.audioGuide')}}</div>
      <material-select :type="2" @selected="handleSelectedLandmark">
        <template slot="body">
          <a-button type="primary" ghost>{{$t('edit.hpInfo.audioSelect')}}</a-button>
        </template>
      </material-select>
      <div class="image-list" v-if="currentAudio.url">
        <audio preload="none" controls="controls" alt="example" :src="currentAudio.url">{{currentAudio.name}}</audio>
        <div class="material-option">
          <span class="m-title">{{currentAudio.name}}</span>
          <span class="m-dele" @click="onClickDel">{{$t('actionTitles.delete')}}</span>
        </div>
      </div>

      <div style="margin:20px 0 10px">{{$t('edit.guide.gap.textHeader')}}</div>
      <a-textarea :placeholder="$t('edit.guide.gap.textHolder')" v-model="contentStr" :rows="6" />
    </div>

    <div class="btn-desc">
      <a-button type="primary" @click="onClickSave">{{$t('actionTitles.save')}}</a-button>
      <a-button @click="clickBack">{{$t('actionTitles.cancel')}}</a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MaterialSelect from "@/components/MaterialSelect";

export default {
  components: { MaterialSelect },
  props: {
    targetObj: {
      type: Object,
      required: true,
    },
  },
  watch: {
    targetObj: {
      handler: function () {
        if (this.targetObj) {
          this.handleDefault();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      fileList: [],
      gapTime: "",
      contentStr: "",
      currentAudio: {},
    };
  },
  computed: { ...mapGetters(["vrbase"]) },
  created() {},
  methods: {
    handleDefault() {
      this.gapTime = this.targetObj.move_time;
      this.contentStr = this.targetObj.content;
      this.currentAudio.url = this.targetObj.music_url;
      this.currentAudio.name = this.targetObj.music_title;
    },
    clickBack() {
      this.$emit("clickBack");
    },
    handleSelectedLandmark(value) {
      this.currentAudio = value;
      console.log(value);
    },
    onClickDel() {
      this.currentAudio  = {}
    },
    onClickSave() {
      const data = this.targetObj;
      data.move_time = this.gapTime;
      data.content = this.contentStr;
      data.music_url = this.currentAudio.url ? this.currentAudio.url  : "";
      data.music_title = this.currentAudio.name ? this.currentAudio.name : "";
      this.$emit("saveChangeData", data);
    },
  },
};
</script>

<style lang="less" scoped>
.image-list {
  padding: 10px 0;
  text-align: center;
  width: 208px;
}
.image-list audio {
  width: 100%;
}
.material-option {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 4px;
  cursor: pointer;
}
.m-title {
  width: 180px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.m-dele {
  width: 30px;
}
</style>